import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Element } from 'react-scroll'

import * as reactUtil from '../../util/react'
import ElementWrapper from './element-wrapper'
import NavigationWrapper from './navigation-wrapper'

import styles from './table-of-contents.module.css'

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    containerId: PropTypes.string.isRequired,
    navigationClassName: PropTypes.string
}

/**
 * Table of contents wrapper for react scroll navigation and content elements.
 *
 * @param {Object} props - Properties for the basic configuration of the component
 * @param {string} props.containerId - The container id which the table of contents elements belong to
 * @param {string} props.className - CSS-class to style the table of contents
 * @param {string} props.navigationClassName - CSS-class to style the navigation wrapper
 * @param {ReactElement[]} props.children - Table of contents element with children
 * @returns {ReactElement}
 */
const TableOfContents = props => {
    const { children, className, containerId, navigationClassName } = props
    const filteredChildren = React.Children.map(children, child => child) // Removes all 'null' children.

    const otherProps = reactUtil.getExtraneousProps(propTypes, props)
    const contentElements = React.Children.map(filteredChildren, (element, index) => {
        return <ElementWrapper element={element} index={index} containerId={containerId} {...otherProps} />
    })

    const composedClassNames = cx(styles['table-of-contents-container'], className)
    return (
        <div className={composedClassNames}>
            <NavigationWrapper containerId={containerId} className={navigationClassName}>
                {filteredChildren}
            </NavigationWrapper>
            <Element name="elementWrapper" className={styles['content-container']} id={containerId}>
                {contentElements}
            </Element>
        </div>
    )
}

TableOfContents.propTypes = propTypes

export default TableOfContents
